import { ReceiptComponentProps } from "../BuilderInterface";
import "./style.scss";
import { getCompoundStyle } from "../helpers";
import { ReceiptNode } from "../../build/types";
import { CartDetails, ProductDetails } from "../PrintLayouts/Receipt";
import { label } from "../../build/constants";
import { ReceiptData } from "../../build/printLayoutTypes";
import { Fragment } from "react";
import classNames from "classnames";

const BuilderReceipt: React.FC<ReceiptComponentProps> = ({
    node,
    receiptData,
    isGift = false,
    builderProps,
    formatCurrency,
    formatAmount
}: ReceiptComponentProps) => {
    const receiptNode = node as ReceiptNode;
    const { id, attr } = receiptNode;

    const formatC = formatCurrency || ((amount?: number) => amount?.toString() || "");
    const formatA = formatAmount || ((amount?: number) => amount?.toString() || "");

    const receiptClassName = classNames("receipt-builder-wrapper", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { selectCallback, outlineCallback, onDragStart, onDragEnd } = builderProps;

        return (
            <div
                {...attr}
                className={receiptClassName}
                style={getCompoundStyle({ node })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={"true"}
                onDragEnd={onDragEnd}
            >
                <div className="receipt">
                    <ProductDetails
                        isGift={false}
                        node={receiptNode}
                        receiptData={receiptData}
                        receiptLabels={label}
                        formatCurrency={formatC}
                        formatAmount={formatA}
                    />
                    <CartDetails
                        isGift={false}
                        node={receiptNode}
                        receiptData={receiptData}
                        receiptLabels={label}
                        formatCurrency={formatC}
                        formatAmount={formatA}
                    />
                    {receiptNode.settings.showSignature && (
                        <div className="print-signature-container">
                            {receiptNode.signature?.label && (
                                <span style={receiptNode.signature?.labelStyle} className="print-signature-label">
                                    {receiptNode.signature.label}
                                </span>
                            )}
                            <div className="sig-relative-container">
                                {receiptData.signature && (
                                    <img
                                        className="print-signature"
                                        src={`data:image/svg+xml;base64,${receiptData.signature}`}
                                        alt="signature"
                                    />
                                )}
                                <div className="sig-underline"></div>
                                <span>x</span>
                            </div>
                            {receiptNode.signature?.subtext && (
                                <span style={receiptNode.signature?.subtextStyle} className="print-signature-subtext">
                                    {receiptNode.signature.subtext}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <div {...attr} className={receiptClassName} style={getCompoundStyle({ node })}>
                <div className="receipt">
                    <ProductDetails
                        isGift={isGift}
                        node={receiptNode}
                        receiptData={receiptData}
                        receiptLabels={label}
                        formatCurrency={formatC}
                        formatAmount={formatA}
                    />
                    <CartDetails
                        isGift={isGift}
                        node={receiptNode}
                        receiptData={receiptData}
                        receiptLabels={label}
                        formatCurrency={formatC}
                        formatAmount={formatA}
                    />

                    {receiptData.refunds && receiptData.refunds.length > 0 ? (
                        <>
                            {receiptData.refunds.map(refund => (
                                <Fragment key={refund.id}>
                                    <p className="receipt-refund-title">** REFUND **</p>
                                    <ProductDetails
                                        isGift={isGift}
                                        node={receiptNode}
                                        receiptData={refund as ReceiptData}
                                        receiptLabels={label}
                                        formatCurrency={formatC}
                                        formatAmount={formatAmount || ((amount?: number) => amount?.toString() || "")}
                                    />
                                    <CartDetails
                                        isGift={isGift}
                                        node={receiptNode}
                                        receiptData={refund as ReceiptData}
                                        receiptLabels={label}
                                        formatCurrency={formatC}
                                        formatAmount={formatA}
                                    />
                                </Fragment>
                            ))}
                        </>
                    ) : null}
                    {receiptNode.settings.showSignature && receiptData.signature && (
                        <div className="print-signature-container">
                            {receiptNode.signature?.label && (
                                <span style={receiptNode.signature?.labelStyle} className="print-signature-label">
                                    {receiptNode.signature.label}
                                </span>
                            )}
                            <div className="sig-relative-container">
                                {receiptData.signature && (
                                    <img
                                        className="print-signature"
                                        src={`data:image/svg+xml;base64,${receiptData.signature}`}
                                        alt="signature"
                                    />
                                )}
                                <div className="sig-underline"></div>
                                <span>x</span>
                            </div>
                            {receiptNode.signature?.subtext && (
                                <span style={receiptNode.signature?.subtextStyle} className="print-signature-subtext">
                                    {receiptNode.signature.subtext}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
};

export default BuilderReceipt;
